import React, { useState } from 'react'
import {
  Button,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import AdsCard from '../../sections/@dashboard/ads/AdsCard';
import { AdsService } from '../../Services/ads.service';
import { useLoadingContext } from '../../context/loadingContext';

const AdsPage = () => {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const [ads, setAds] = useState([]);
  const { handleStartLoading, handleStopLoading } = useLoadingContext();


  React.useEffect(() => {
    GetAds().finally(handleStopLoading);
  }, []);

  const GetAds = async () => {
    handleStartLoading()
    const adsData = await AdsService.GetAds();
    setAds(adsData);
  };

  const handleDisableAds = React.useCallback(
    (id) => {
      handleStartLoading()
      AdsService.DisableAds(id)
        .then(() => {
          const newData = ads.map((item) => {
            if (item._id === id) item.status = 'Disable';
            return item;
          });
          setAds(newData);
          enqueueSnackbar('Thành công', { variant: 'success' });
        })
        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        .finally(handleStopLoading);
    },
    [ads]
  );

  const handleEnableAds = React.useCallback(
    (id) => {
      handleStartLoading()
      AdsService.EnableAds(id)
        .then(() => {
          const newData = ads.map((item) => {
            if (item._id === id) item.status = 'Enable';
            return item;
          });
          setAds(newData);
          enqueueSnackbar('Thành công', { variant: 'success' });
        })
        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        .finally(handleStopLoading);
    },
    [ads]
  );

  const handleEditAds = React.useCallback((_id) => navigate(`/ctkm/${_id}`), []);

  const handleDeleteAds = React.useCallback(
    (id) =>
      Swal.fire({
        customClass: {
          container: { zIndex: 999999 },
        },
        title: 'Xóa quảng cáo',
        text: 'Thao tác này không thể hoàn tác',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t('sure.yes'),
        cancelButtonText: t('sure.no'),
      }).then((result) => {
        if (result.isConfirmed) {
          handleStartLoading()
          AdsService.DeleteAds(id)
            .then(() => {
              const newData = ads.filter((adss) => adss._id !== id);
              setAds(newData);
              enqueueSnackbar('Thành công', { variant: 'success' });
            })
            .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
            .finally(handleStopLoading)
        }
      }),
    [ads]
  );

  return (
    <Page title={'Promotion'}>
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Quảng cáo
          </Typography>
          <Button
            variant="contained"
            component={RouterLink}
            to="/ctkm/create"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            Thêm quảng cáo
          </Button>
        </Stack>

        {ads.map((adss) => (
          <AdsCard
            key={adss._id}
            adss={adss}
            onEdit={handleEditAds}
            onDisable={handleDisableAds}
            onEnable={handleEnableAds}
            onDelete={handleDeleteAds}
          />
        ))}
      </Container>
    </Page>
  )
}

export default AdsPage